import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { Field, reduxForm, getFormSyncErrors } from 'redux-form';
import { IModalAction } from 'models/modal';
import { IDomainValue } from 'models/common';
import { IStore } from 'redux/IStore';
import { updateShopCustomer } from 'redux/modules/shop/shopcard';
import { Dispatch } from 'react-redux';
import { ICustomer } from 'models/shop/customer';
import { PortalPageSection } from 'components/PortalStructure';
import { Button } from 'components';
import { BookingTextareaField } from 'components/FormControls';
const { connect } = require('react-redux');

interface ICustomerData {
	notes: string;
}

interface IProps extends ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
	/* form props */
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;
	handleSubmit: any;
	submitFailed: boolean;

	/* functions props */
	t?: (key: string) => string;
	change?: (field: any, value: any) => void;
	onSubmit?: (form: ICustomerData) => void;
	showModal: (modalType: string, modalProps: any) => IModalAction;
	closeModal: () => IModalAction;
	onFormOpen?: () => void;

	/* other props */
	countryDomainValues: IDomainValue[];
	readOnly: boolean;
	selectedTab: string;
	customCardClassName?: string;
}

interface IState {
	editing: boolean;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShopCustomerNotesForm extends React.Component<IProps, IState> {
	deleteImage: any;

	constructor(props) {
		super(props);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.state = {
			editing: false,
		};
	}

	componentDidUpdate(prevProps) {
		if (prevProps.readOnly !== this.props.readOnly && this.props.readOnly === false) {
			this.handleClose();
		}

		if (prevProps.selectedTab !== this.props.selectedTab && this.props.selectedTab !== 'bio') {
			this.handleClose();
		}
	}

	public onSubmit(form: ICustomerData) {
		const notes = form?.notes;
		this.props
			.updateShopCustomer({ notes })
			.then(() => {
				this.setState({ editing: false });
			})
			.catch((e) => {
				console.error(e);
			});
	}

	public handleClick() {
		this.setState({ editing: !this.state.editing });
		this.props.onFormOpen();
	}

	public handleClose() {
		this.setState({ editing: false });
	}

	public render() {
		const { handleSubmit, t, selectedCustomer, customCardClassName } = this.props;
		const { editing } = this.state;

		const notes = selectedCustomer?.notes || '';
		return (
			<form onSubmit={handleSubmit(this.onSubmit)} className="notes">
				<PortalPageSection
					title={t('User_UserCard_NotesTitle')}
					className={`customerNotes ${customCardClassName ? customCardClassName : ''}`}
					variant="dark"
					toggleEdit={this.handleClick}
					readOnly={!editing}
				>
					{editing ? (
						<>
							<Field name="notes" component={BookingTextareaField} type="text" maxLength={500} />
							<Button className="formButton" type="submit">
								{t('BSPortal_Common_Save')}
							</Button>
						</>
					) : (
						<p className={`${notes ? 'customerNote' : 'grayGigo'}`}>{notes ? notes : t('User_UserCard_NotesText')}</p>
					)}
				</PortalPageSection>
			</form>
		);
	}
}

function mapStateToProps(state: IStore) {
	let currentFormValues: ICustomerData = null;
	if (state.form[c.FORM_NAME_CUSTOMER] && state.form[c.FORM_NAME_CUSTOMER].values) {
		currentFormValues = state.form[c.FORM_NAME_CUSTOMER].values;
	}
	const selectedCustomer = state.shopcard.selectedCustomer;
	let notes = '';
	if (state.shopcard && state.shopcard.selectedCustomer) {
		notes = selectedCustomer?.notes || '';
	}
	return {
		initialValues: {
			notes,
		},
		selectedCustomer,
		currentFormValues,
		formErrors: getFormSyncErrors(c.FORM_NAME_CUSTOMER)(state),
	};
}

let ShopCustomerNotes = reduxForm(
	{
		form: c.FORM_NAME_CUSTOMER,
		enableReinitialize: true,
	},
	mapStateToProps,
)(ShopCustomerNotesForm);

function mapDispatchToProps(dispatch: Dispatch<IStore>) {
	return {
		updateShopCustomer: (notes: Partial<ICustomer>) => dispatch(updateShopCustomer(notes)),
	};
}

ShopCustomerNotes = connect(mapStateToProps, mapDispatchToProps)(ShopCustomerNotes);

export { ShopCustomerNotes };
